<template>
  <div class="row">
    <div class="col-12 px-3">
      <div class="dashboard">
        <div class="row px-1">
          <div class="item bg-gradient-info col-12 col-md-3 p-2">
            <img
              src="@/assets/images/lines.svg"
              class="card-img-absolute"
              alt="circle-image"
            />
            <div class="text-center">
              Total de horas alocadas
              <b-badge variant="light">Planejado</b-badge>
            </div>
            <h4 class="mt-2 text-center text-white">
              {{ totalHorasPrevisto }} Hrs
            </h4>
          </div>
          <div class="item bg-gradient-info col-12 col-md-3 p-2">
            <img
              src="@/assets/images/lines.svg"
              class="card-img-absolute"
              alt="circle-image"
            />
            <div class="text-center">
              Valor total <b-badge variant="light">Planejado</b-badge>
            </div>
            <h4 class="mt-2 text-center text-white">
              {{ totalValorPrevisto }}
            </h4>
          </div>
          <div class="item bg-gradient-success col-12 col-md-3 p-2">
            <img
              src="@/assets/images/lines.svg"
              class="card-img-absolute"
              alt="circle-image"
            />
            <div class="text-center">
              Total de horas alocadas
              <b-badge variant="light">Realizado</b-badge>
            </div>
            <h4 class="mt-2 text-center text-white">
              {{ totalHorasRealizado }} Hrs
            </h4>
          </div>
          <div class="item bg-gradient-success col-12 col-md-3 p-2">
            <img
              src="@/assets/images/lines.svg"
              class="card-img-absolute"
              alt="circle-image"
            />
            <div class="text-center">
              Valor total <b-badge variant="light">Realizado</b-badge>
            </div>
            <h4 class="mt-2 text-center text-white">
              {{ totalValorRealizado }}
            </h4>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      title="Filtro declaração HH"
      id="modalHH"
      ok-variant="success"
      ok-title="Gerar declaração"
      cancel-title="Fechar"
      @ok="gerarDeclaracao"
    >
      <modal-h-h :projeto="projeto" ref="modalDeclaracao" />
    </b-modal>
    <select-modal
      id="RH"
      placeholder-button="Inserir"
      titleModal="INSERIR PESSOA"
      :modal-fields="colunasModal"
      :fetch-method="metodoBusca"
      term-initial="nome"
      slot-image="foto"
      :values="selecao"
      :function-map="
        (el) => {
          return el.pessoa.id;
        }
      "
      hide-selected
      hide-button
      class-button="px-3 py-3"
      :btn-inserir="permissaoPessoas.c"
      btn-tipo="pessoas"
      @update="metodoAdicionar"
      :controles="true"
      ref="selectModal"
      class="col-12"
    >
      <template #before-table>
        <accordion :id="`rh-1`" title="Planejado" sub accordion="rh-1" visible>
          <template #append-title>
            <div>
              <b-button
                variant="info"
                size="sm"
                v-if="projetoEditavel && !projetoIniciado && permissaoRH.c"
                class="ml-2"
                @click="abrirSelecaoPrevisto"
                >Inserir previsão</b-button
              >
            </div>
          </template>
          <div class="p-3">
            <tabela
              :realizada="projetoIniciado"
              :duracao="duracao"
              :itens="previsto"
              :controles="projetoEditavel && !projetoIniciado"
              @atualizar="salvarPessoa($event, false)"
              @deletar="deletarPessoa($event, false)"
              :projeto="projeto"
            />
          </div>
        </accordion>
      </template>
      <template #table>
        <div>
          <accordion
            v-if="projetoIniciado"
            :id="`rh-2`"
            title="Realizado"
            sub
            accordion="rh-2"
            visible
          >
            <template #append-title>
              <div class="d-flex">
                <b-button
                  variant="info"
                  size="sm"
                  class="ml-2"
                  @click="abrirSelecaoRealizado"
                  v-if="projetoEditavel && permissaoRH.c"
                  >Adicionar pessoa</b-button
                >
                <b-button
                  variant="success"
                  size="sm"
                  class="ml-2"
                  @click="baixarRelatorioHH"
                >
                  <i class="fas fa-cloud-download mr-2"></i>
                  Declaração HH
                </b-button>
              </div>
            </template>
            <div class="p-3">
              <tabela
                realizada
                :duracao="duracao"
                :itens="realizado"
                :controles="projetoEditavel"
                @atualizar="salvarPessoa($event, true)"
                @deletar="deletarPessoa($event, true)"
                :projeto="projeto"
              />
            </div>
          </accordion>
          <accordion
            v-if="projetoIniciado"
            :id="`rh-3`"
            title="ARMAZENAR DECLARAÇÃO DE RH"
            sub
            accordion="rh-3"
            visible
          >
            <div>
              <formulario-h-h
                ref="comprovantehh"
                :equipe-id="equipeId"
                :projeto="projeto"
                :projeto-editavel="projetoEditavel"
              />
            </div>
          </accordion>
        </div>
      </template>
    </select-modal>
  </div>
</template>
<script>
import SelectModal from "@/components/modal/SelectModal.vue";
import Accordion from "@/components/card/Accordion.vue";
import ProjetoGestaoService from "@/common/services/projeto_gestao/projeto_gestao.service";
import PessoaService from "@/common/services/pessoa/pessoa.service";
import Tabela from "./componentes/Tabela";

import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import helpers from "@/common/utils/helpers";
import cloneDeep from "lodash/cloneDeep";

import FormularioHH from "./componentes/FormularioHH";
import ModalHH from "./componentes/ModalHH.vue";

export default {
  mixins: [AlertasMixin],
  props: {
    projeto: {
      type: Object,
      default: null,
    },
    projetoEditavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectModal,
    Tabela,
    Accordion,
    FormularioHH,
    ModalHH,
  },
  data: () => ({
    colunasModal: [
      { key: "acoes", label: "Ações", tdClass: "acoes" },
      { key: "foto", label: "" },
      { key: "nome", label: "Nome" },
      { key: "email", label: "E-mail" },
      { key: "endereco.cidade", label: "Cidade" },
      { key: "titulacao", label: "Titulação" },
    ],
    realizado: [],
    previsto: [],

    equipeId: null,

    selecao: [],
    metodoAdicionar: null,
  }),
  methods: {
    abrirSelecaoPrevisto: function (e) {
      e.stopPropagation();
      this.selecao = cloneDeep(this.previsto);
      this.$refs.selectModal.openModal();
      this.metodoAdicionar = this.adicionarPessoaPrevisto;
    },

    abrirSelecaoRealizado: function (e) {
      e.stopPropagation();
      this.selecao = cloneDeep(this.realizado);
      this.$refs.selectModal.openModal();
      this.metodoAdicionar = this.adicionarPessoaRealizado;
    },

    metodoBusca: function () {
      return PessoaService.listar(this.empresaSelecionada.id);
    },

    adicionarPessoaPrevisto: function (item) {
      this.adicionarPessoa(item, false);
    },

    adicionarPessoaRealizado: function (item) {
      this.adicionarPessoa(item, true);
    },

    adicionarPessoa: function (item, realizado) {
      let form = {
        pessoaId: item.item.id,
      };
      if (this.telaProponente) {
        form.projetoGestaoId = this.projeto.id;
      } else {
        form.projetoGestaoCooperadaId = this.projeto.id;
      }

      this.$store.dispatch(START_LOADING);
      ProjetoGestaoService.adicionarRH(
        form,
        realizado,
        this.telaProponente ? "ProjetoGestao" : "ProjetoGestaoCooperada"
      )
        .then(() => {
          this.toast("Pessoa adicionada com sucesso!", { variant: "success" });
          if (realizado) this.buscarRealizado();
          else this.buscarPrevisto();
        })
        .catch(() => {
          this.toast("Erro ao adicionar pessoa!", { variant: "error" });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    salvarPessoa: function (item, realizado) {
      let form = cloneDeep(item);
      if (this.telaProponente) {
        form.projetoGestaoId = this.projeto.id;
      } else {
        form.projetoGestaoCooperadaId = this.projeto.id;
      }
      form.alocacaoHoraIndividualId = item.id;
      form.valorHora = helpers.removerValor(item.valorHora);

      this.confirmar("Aviso", "Tem certeza que deseja alterar os dados?").then(
        (confirmado) => {
          if (!confirmado) return;

          this.$store.dispatch(START_LOADING);
          ProjetoGestaoService.salvarRH(
            form,
            realizado,
            this.telaProponente ? "ProjetoGestao" : "ProjetoGestaoCooperada"
          )
            .then(() => {
              this.toast("Pessoa salva com sucesso!", { variant: "success" });
              if (realizado) this.buscarRealizado();
              else this.buscarPrevisto();
            })
            .catch((err) => {
              if (!err.response)
                this.toast("Erro ao salvar pessoa!", { variant: "error" });

              this.alertaErro(err.response.data.errors);
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      );
    },

    deletarPessoa: function (item, realizado) {
      let form = {
        id: item.id,
      };

      this.confirmar(
        "Aviso",
        "Tem certeza que deseja excluir esta pessoa?"
      ).then((confirmado) => {
        if (!confirmado) return;

        this.$store.dispatch(START_LOADING);
        ProjetoGestaoService.deletarRH(form, realizado)
          .then(() => {
            this.toast("Pessoa excluida com sucesso!", { variant: "success" });
            if (realizado) this.buscarRealizado();
            else this.buscarPrevisto();
          })
          .catch(() => {
            this.toast("Erro ao excluir pessoa!", { variant: "error" });
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },

    buscarRealizado: function () {
      this.$store.dispatch(START_LOADING);
      ProjetoGestaoService.listarRH(
        this.projeto.id,
        true,
        this.telaProponente ? "ProjetoGestao" : "ProjetoGestaoCooperada",
        this.telaProponente ? "ProjetoGestaoId" : "ProjetoGestaoCooperadaId"
      )
        .then((res) => {
          this.equipeId = res.data.data.itens[0].id;
          this.realizado = res.data.data.itens
            ? res.data.data.itens.length > 0
              ? res.data.data.itens[0].equipe.alocacaoHorasIndividuais
              : []
            : [];
          this.$refs.comprovantehh.montar(this.equipeId);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    buscarPrevisto: function () {
      this.$store.dispatch(START_LOADING);
      ProjetoGestaoService.listarRH(
        this.projeto.id,
        false,
        this.telaProponente ? "ProjetoGestao" : "ProjetoGestaoCooperada",
        this.telaProponente ? "ProjetoGestaoId" : "ProjetoGestaoCooperadaId"
      )
        .then((res) => {
          this.previsto = res.data.data.itens
            ? res.data.data.itens.length > 0
              ? res.data.data.itens[0].equipe.alocacaoHorasIndividuais
              : []
            : [];
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    montar: function () {
      this.buscarPrevisto();
      this.buscarRealizado();
    },

    gerarDeclaracao: function (e) {
      e.preventDefault();

      let form = this.$refs.modalDeclaracao.getForm();

      this.$store.dispatch(START_LOADING);
      this.$nextTick(() => {
        this.$bvModal.hide("modalHH");
      });
      ProjetoGestaoService.baixarHH(this.projeto.id, form.pessoaId, form.data)
        .then((res) => {
          this.$store.dispatch(STOP_LOADING);
          const blob = new Blob([res.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `Declaração HH.pdf`;
          link.click();
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    baixarRelatorioHH: function (e) {
      e.stopPropagation();

      this.$bvModal.show("modalHH");
    },
  },
  computed: {
    empresaSelecionada() {
      return this.$store.state.app.selectedCompanyObj;
    },

    horasSazonaisPrevisto: function () {
      let horas = [];
      for (let index = 0; index < this.duracao; index++) {
        let quantidade = 0;
        this.previsto.forEach((element) => {
          quantidade += element.horasSazonais.find((el) => el.mes == index)
            ? element.horasSazonais.find((el) => el.mes == index).horas
            : 0;
        });
        horas.push({
          mes: index,
          horas: quantidade,
        });
      }
      return horas;
    },
    horasSazonaisRealizado: function () {
      let horas = [];
      for (let index = 0; index < this.duracao; index++) {
        let quantidade = 0;
        this.realizado.forEach((element) => {
          quantidade += element.horasSazonais.find((el) => el.mes == index)
            ? element.horasSazonais.find((el) => el.mes == index).horas
            : 0;
        });
        horas.push({
          mes: index,
          horas: quantidade,
        });
      }
      return horas;
    },

    valorPessoaPrevisto: function () {
      return this.previsto.reduce(
        (total, pessoa) =>
          total + (pessoa.valorHora ? parseInt(pessoa.valorHora) : 0),
        0
      );
    },
    valorPessoaRealizado: function () {
      return this.realizado.reduce(
        (total, pessoa) =>
          total + (pessoa.valorHora ? parseInt(pessoa.valorHora) : 0),
        0
      );
    },

    totalHorasPrevisto: function () {
      return this.horasSazonaisPrevisto.reduce(
        (total, hora) => total + parseInt(hora.horas),
        0
      );
    },
    totalHorasRealizado: function () {
      return this.horasSazonaisRealizado.reduce(
        (total, hora) => total + parseInt(hora.horas),
        0
      );
    },

    totalValorPrevisto: function () {
      return helpers.formatarValor(
        this.previsto.reduce((total, pessoa) => {
          return (
            total +
            pessoa.horasSazonais.reduce(
              (total, hora) => total + parseInt(hora.horas),
              0
            ) *
              pessoa.valorHora
          );
        }, 0)
      );
    },
    totalValorRealizado: function () {
      return helpers.formatarValor(
        this.realizado.reduce((total, pessoa) => {
          return (
            total +
            pessoa.horasSazonais.reduce(
              (total, hora) => total + parseInt(hora.horas),
              0
            ) *
              pessoa.valorHora
          );
        }, 0)
      );
    },

    projetoIniciado: function () {
      if (!this.telaProponente)
        return this.projeto.projetoGestao.faseRealizacao;
      return this.projeto.faseRealizacao;
    },

    telaProponente: function () {
      return this.$route.name == "projeto-gestao-proponente-detalhamento";
    },
    duracao: function () {
      if (!this.telaProponente) return this.projeto.projetoGestao.duracao;
      return this.projeto.duracao;
    },

    permissaoRH() {
      return this.$store.getters["app/retornaPermissao"](
        "ProjetosGestaoRecursoHumano"
      );
    },

    permissaoPessoas() {
      return this.$store.getters["app/retornaPermissao"]("Pessoas");
    },
  },
  beforeMount() {
    this.metodoAdicionar = this.adicionarPessoaPrevisto;
  },
};
</script>
<style>
.dashboard .item {
  border-right: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  font-size: 13px;
  color: #fff;
}
.card-img-absolute {
  position: absolute;
  top: 0;
  right: 0;
  height: 73px;
  width: 100%;
  object-fit: cover;
}
</style>
